import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface InfoTipProps {
  // 트리거는 아이콘뿐이라 스크린리더용 라벨 필수(예: "부족·품절 집계 기준").
  ariaLabel: string;
  children: ReactNode;
}

/**
 * 라벨 옆 ⓘ 툴팁(카피 개편 2026-07-16 — 집계 기준·차감 동작 같은 설명을 상시 캡션 대신
 * 궁금한 순간에만 노출). 로컬 TooltipProvider 래핑은 이 레포 관례(DepositRow 선례),
 * 트리거를 button으로 두어 hover 외에 키보드 포커스로도 열린다.
 */
export function InfoTip({ ariaLabel, children }: InfoTipProps) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={ariaLabel}
            className="inline-flex shrink-0 cursor-help align-middle text-slate-300 hover:text-slate-500 focus-visible:text-slate-500"
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        {/* text-balance: 줄 길이를 균등 분배해 마지막 줄에 한 단어("수예요")만 남는 고아 줄
            방지(오너 지적 2026-07-16). py-2는 두 줄 이상 문구의 답답한 상하 여백 보정. */}
        <TooltipContent className="max-w-64 text-balance break-keep px-3 py-2 text-xs font-normal leading-relaxed">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
